import { httpClient } from './http-client';
import { BecomeLenderPayload, SendFeedbackPayload } from './types';

export const sendFeedback = (payload: SendFeedbackPayload) => (
  httpClient.post("/feedback/get-in-touch", payload)
)

export const becomeLender = (payload: BecomeLenderPayload) => (
  httpClient.post("/feedback/become-lender", payload)
)